import { makeStyles } from '@material-ui/styles';

export const useDaySelectStyles = makeStyles(
    theme => ({
        container: {
            color: theme.customization.background.G10,
            alignItems: 'center',
            position: 'relative',
            display: 'flex',
            maxWidth: 230,
            // TODO: return back normal width when bug with filters will be solved
            // '&.md': {
            //     maxWidth: 500,
            // },
        },
        arrowIcon: {
            position: 'relative',
            zIndex: 2,
        },
        left: {
            pointerEvents: 'none',
            position: 'absolute',
            top: 0,
            left: 0,
            height: '100%',
            width: 50,
            zIndex: 1,
            background: `linear-gradient(270deg, ${theme.customization.background.C10}00, ${theme.customization.background.C10})`,
        },
        right: {
            pointerEvents: 'none',
            position: 'absolute',
            top: 0,
            right: 0,
            height: '100%',
            width: 50,
            zIndex: 1,
            background: `linear-gradient(270deg, ${theme.customization.background.C10}, ${theme.customization.background.C10}00)`,
        },
        disabled: {
            cursor: 'default',
            color: `${theme.customization.background.G10}4D`,
        },
        select: {
            position: 'relative',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            scrollBehavior: 'smooth', // block the JS scroll on safari
            transition: 'all 1s ease 0s',
            width: '100%',
            '& > * + *': {
                marginLeft: 4,
            },
            // hack for safari - TODO: check after safari release new version
            '@media not all and (min-resolution:.001dpcm) { @supports (-webkit-appearance:none) and (display:flow-root)':
                {
                    scrollBehavior: 'auto',
                },
        },
    }),
    { classNamePrefix: 'days-select' }
);

export const useOptionStyles = makeStyles(
    theme => ({
        option: {
            position: 'relative',
            cursor: 'pointer',
            display: 'inline-block',
            padding: '4px 8px',
            '&:hover': {
                backgroundColor: theme.customization.background.C20,
                borderRadius: 6,
            },

            '&:focus': {
                outline: 'none',
            },
        },
        label: {
            ...theme.typography.t61,
            display: 'inline-block',
            position: 'relative',
            color: theme.customization.background.G10,
            userSelect: 'none',
            textDecoration: 'none',

            '&::after': {
                content: '""',
                display: 'block',
                position: 'absolute',
                height: 2,
                bottom: 2,
                left: 0,
                width: '30%',
            },
        },
        labelSelected: {
            color: theme.customization.background.G10,
            fontWeight: 700,
            transition: 'all .3s ease 0s',
            '&::after': {
                width: '100%',
                backgroundColor: 'currentColor',
                transition: 'width .3s ease 0s',
            },
        },
    }),
    { classNamePrefix: 'options' }
);
